/**
 * Private Route Component
 * Protects routes that require authentication
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, ownerOnly = false, partnerOnly = false }) => {
  const { isAuthenticated, isOwner, isSuperuser, isPartner, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={partnerOnly ? '/login?bereich=partner' : '/login'} />;
  }

  // Physios sehen nur den Partnerbereich, Mitglieder nie
  if (partnerOnly && !isPartner()) {
    return <Navigate to="/" />;
  }
  if (!partnerOnly && isPartner()) {
    return <Navigate to="/partner" />;
  }

  if (ownerOnly && !isOwner() && !isSuperuser()) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
